import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'sectionInteraction',
  store,
  dynamic: true
})
class SectionInteractionStoreModule extends VuexModule {
  public sectionIdsByInteraction: { [interactionId: string]: string } = {};
  public interactionStates: { [interactionId: string]: boolean } = {};

  @Mutation
  public setInteraction(value: { interactionId: string; sectionId: string; }): void {
    this.sectionIdsByInteraction[value.interactionId] = value.sectionId;
  }

  @Mutation
  public setInteractionState(value: { interactionId: string; completed: boolean; }): void {
    this.interactionStates[value.interactionId] = value.completed;
  }
}

export default getModule(SectionInteractionStoreModule);
